module.exports = __webpack_public_path__ + "static/media/PlayfairDisplay-ExtraBold.91c2359d.eot";